import request from '@/utils/request'

export function fetchDetail(data) {
  return request({
    url: 'api/adopt/getAdoptInfo',
    method: 'post',
    data
  })
}